import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@/lib';

const STEPS = [
  {
    number: 1,
    translationKey: 'sidebar.steps.configureData',
  },
  {
    number: 2,
    translationKey: 'sidebar.steps.competitorScan',
  },
  {
    number: 3,
    translationKey: 'sidebar.steps.positioningGap',
  },
  {
    number: 4,
    translationKey: 'sidebar.steps.strategicActions',
  },
] as const;

export const MarketIntelligenceSidebar: FC = () => {
  const { t } = useTranslation('marketIntelligence');

  return (
    <div className='w-full space-y-6'>
      {/* How it works */}
      <Card className='block rounded-lg border-primary-border bg-white p-6 drop-shadow-none'>
        <h3 className='mb-4 font-semibold text-primary-900'>{t('sidebar.howItWorks')}</h3>
        <div className='space-y-4'>
          {STEPS.map((step) => (
            <div key={step.number} className='flex gap-3'>
              <div className='flex items-center justify-center w-6 h-6 rounded-full bg-brand-600 text-white-100 text-xs font-semibold flex-shrink-0'>
                {step.number}
              </div>
              <div>
                <div className='font-bold text-sm text-primary-900'>{t(`${step.translationKey}.title`)}</div>
                <div className='text-xs text-grey-600'>{t(`${step.translationKey}.description`)}</div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
};
